// export const API_URL = "http://localhost:8088/api/v1"

// export const API_URL = "http://10.154.11.117:8088/api/v1"

// export const API_URL = "http://10.200.238.26/api/v1"

export const API_URL = "https://zantel.ewallet-dev.com/api/v1"
